"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { Suspense, useEffect } from "react";
import { useWizardTranslation } from "@/libs/i18n/use-wizard-translation";

function Content() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { t } = useWizardTranslation();

  useEffect(() => {
    if (!searchParams) return;
    const queryString = searchParams.toString();
    const redirectUrl = `/${t("presupuesto", "quote")}?${queryString}`;
    router.push(redirectUrl);
  }, [searchParams, router, t]);

  return <div />;
}

export default function Page() {
  return (
    <Suspense fallback={<div />}>
      <Content />
    </Suspense>
  );
}
